import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { BalanceSheetScreen } from '@/features/accounting-reports/balance-sheet-screen'
import {
  type StatementSearch,
  statementSearchFrom,
} from '@/features/accounting-reports/monthly-statements-api'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/reports/balance-sheet')({
  validateSearch: (search: Record<string, unknown>): StatementSearch => statementSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: BalanceSheetRoute,
})

function BalanceSheetRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <BalanceSheetScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/accounting/reports/balance-sheet', search: next })
      }
    />
  )
}
